if (!customElements.get('togi-support')) {
  class TogiSupport extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('button');
        if (!button || TogiSupport.busy) return;
        const selected = button.dataset.variantId;
        if (!selected && !button.hasAttribute('data-remove')) return;
        event.preventDefault();
        TogiSupport.busy = true;
        const controls = [...document.querySelectorAll('togi-support button, button[name="checkout"]')];
        const states = controls.map(control => control.disabled);
        controls.forEach(control => { control.disabled = true; });
        this.setAttribute('aria-busy', 'true');
        const status = this.querySelector('[role="status"]');
        status.textContent = '';
        try {
          const root = window.Shopify.routes.root;
          const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error();
          const cart = await cartResponse.json();
          const updates = {};
          cart.items.filter(item => String(item.product_id) === this.dataset.productId).forEach(item => {
            updates[item.key] = 0;
          });
          if (selected) {
            const matching = cart.items.find(item => String(item.variant_id) === selected);
            updates[matching ? matching.key : selected] = 1;
          }
          const response = await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates })
          });
          if (!response.ok) throw new Error();
          const result = await response.json();
          const supportItems = result.items.filter(item => String(item.product_id) === this.dataset.productId);
          if (selected && (supportItems.length !== 1 || String(supportItems[0].variant_id) !== selected || supportItems[0].quantity !== 1)) throw new Error();
          if (!selected && supportItems.length !== 0) throw new Error();
          const destination = new URL(root + 'cart', window.location.origin);
          const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (previewId) destination.searchParams.set('preview_theme_id', previewId);
          window.location.assign(destination.href);
        } catch {
          status.textContent = this.dataset.error;
          controls.forEach((control,index) => { control.disabled = states[index]; });
          this.removeAttribute('aria-busy');
          TogiSupport.busy = false;
        }
      });
    }
  }
  customElements.define('togi-support', TogiSupport);
}
